import { LeafIcon } from "./Reveal";

const ITEMS = ["Grounds Maintenance", "Retaining Walls", "Gravel Driveways", "Walkways", "Landscaping A–Z", "Locally Owned", "Licensed & Insured"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((t, i) => (
      <span key={t} className="flex items-center">
        <span className={`px-8 text-4xl sm:text-6xl ${i % 2 ? "font-serif-i text-[#cfe8c9]" : "font-display font-black text-white"}`}>{t}</span>
        <LeafIcon fill="#8fc77f" className="h-7 w-7 rotate-45" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee" className="relative overflow-hidden bg-[var(--leaf)] py-8 sm:py-10">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
